import React, { useState, useEffect, useRef, useCallback } from 'react';
import { getActiveSurveyNotification } from '../lib/surveyHelpers';
import SurveyModal from './SurveyModal';
import './NotificationBell.css';

const POLL_INTERVAL_MS = 60000; // recheck every 60s while the tab is open

// userId here is the app's users.id (not auth.uid()) — pass whatever
// your Dashboard/App already resolves as the current user's row id.
const NotificationBell = ({ userId }) => {
  const [items, setItems] = useState([]); // array of notification objects, currently only 'survey' type
  const [open, setOpen] = useState(false);
  const [activeSurvey, setActiveSurvey] = useState(null); // question object when modal is open
  const dropdownRef = useRef(null);

  const refresh = useCallback(async () => {
    if (!userId) return;
    const surveyNotif = await getActiveSurveyNotification(userId);
    // Future: merge in peer review offer checks here, e.g.
    // const peerReviewNotif = await getPeerReviewOffer(userId);
    const next = [];
    if (surveyNotif) next.push(surveyNotif);
    setItems(next);
  }, [userId]);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [refresh]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleItemClick = (item) => {
    setOpen(false);
    if (item.type === 'survey') {
      setActiveSurvey(item.question);
    }
    // Future: else if (item.type === 'peer_review_offer') open that modal instead
  };

  const handleSurveySubmitted = () => {
    setActiveSurvey(null);
    refresh(); // pulls it out of the list immediately since a response now exists
  };

  return (
    <div className="notification-bell-wrap" ref={dropdownRef}>
      <button
        className="notification-bell-btn"
        onClick={() => setOpen((o) => !o)}
        aria-label="Notifications"
      >
        🔔
        {items.length > 0 && (
          <span className="notification-badge">{items.length}</span>
        )}
      </button>

      {open && (
        <div className="notification-dropdown">
          {items.length === 0 ? (
            <div className="notification-empty">No new notifications</div>
          ) : (
            items.map((item, idx) => (
              <button
                key={idx}
                className="notification-item"
                onClick={() => handleItemClick(item)}
              >
                <div className="notification-item-title">
                  {item.type === 'survey' ? '📋 Weekly Survey' : 'Notification'}
                </div>
                <div className="notification-item-preview">
                  {item.type === 'survey' ? item.question.question_text : ''}
                </div>
              </button>
            ))
          )}
        </div>
      )}

      {activeSurvey && (
        <SurveyModal
          question={activeSurvey}
          userId={userId}
          onClose={() => setActiveSurvey(null)}
          onSubmitted={handleSurveySubmitted}
        />
      )}
    </div>
  );
};

export default NotificationBell;
